import store from "../store";

export function navigateToNuxtApp(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!normalized.startsWith("/app/")) {
    throw new Error(`Expected path under /app/, got: ${path}`);
  }
  window.location.assign(normalized);
}

export function openStudentTasksPending() {
  let path = "/app/tasks/pending";
  const profile = store.getters.profile;
  const student = store.getters.student;
  if (profile?.role === "TEACHER" && student?.uuid) {
    path += `?student=${encodeURIComponent(student.uuid)}`;
  }
  navigateToNuxtApp(path);
}
